// Module Import
//---------------------------------
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'
import TypographyAtom from '../../atoms/typography/typography'
import { brandIvory } from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const AccordionWrapper = styled.div`
  background: ${brandIvory};
  display: flex;
  flex-direction: column;
  width: 100%;
`

const AccordionHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 48px;
  justify-content: space-between;
  padding: 36px;
  width: 100%;

  H5 {
    margin: 0;
  }
`

const AccordionBody = styled.div`
  padding: 0 36px 36px 36px;
`

const Icon = styled.div`
  height: 24px;
  width: 24px;
`

const closed = {
  display: 'none',
}

const open = {
  display: 'block',
}

// Component Export
//---------------------------------
export default function Accordion({ header, body, fieldsNames = {} }) {
  const [accordionStatus, setaccordionStatus] = useState('false')
  const openAccordion = () => {
    setaccordionStatus(!accordionStatus)
  }

  return (
    <AccordionWrapper
      onClick={() => {
        openAccordion()
      }}
    >
      <AccordionHeader>
        <TypographyAtom type="H5" copy={header} weight="Bold" />
        <Icon>
          <StaticImage
            src="../../../assets/images/logo_bladeOrange.png"
            width={148}
            height={150}
            alt=""
          />
        </Icon>
      </AccordionHeader>
      <AccordionBody style={accordionStatus ? closed : open}>
        <TypographyAtom type="BlockText" copyBlock={body} weight="BlockText" />
      </AccordionBody>
    </AccordionWrapper>
  )
}
Accordion.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.shape({}).isRequired,
}
